/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const FETCH_ME_REQUEST = 'medarbeiderne-minside/Auth/FETCH_ME_REQUEST';
export const FETCH_ME_SUCCESS = 'medarbeiderne-minside/Auth/FETCH_ME_SUCCESS';
export const FETCH_ME_FAILURE = 'medarbeiderne-minside/Auth/FETCH_ME_FAILURE';

export const CHANGE_ME_REQUEST = 'medarbeiderne-minside/Auth/CHANGE_ME_REQUEST';
export const CHANGE_ME_SUCCESS = 'medarbeiderne-minside/Auth/CHANGE_ME_SUCCESS';
export const CHANGE_ME_FAILURE = 'medarbeiderne-minside/Auth/CHANGE_ME_FAILURE';

export const STATE_RESET = 'medarbeiderne-minside/Auth/STATE_RESET';
export const LOADING = 'medarbeiderne-minside/Auth/LOADING';